<div *ngIf="isLoading" class="loader">
  <app-loading [onlyIcon]="true"></app-loading>
</div>
<div *ngIf="!isLoading" class="change-password modal">
  <div class="modal">
    <div class="modal__top">
      <span class="modal__title">{{ 'BREADCRUMBS.CHANGE_PASSWORD' | i18nextEager | uppercase }}</span>
      <span class="modal__click" (click)="closeDialog()">
        <img src="/assets/icons/close_modal.svg" alt="" />
      </span>
    </div>
    <div class="modal__body change-password__body">
      <form class="change-password__form" [formGroup]="changePasswordForm">
        <p class="change-password__description">{{ 'CHANGE_PASSWORD.DESCRIPTION' | i18nextEager }}</p>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'CHANGE_PASSWORD.NEW_PASSWORD' | i18nextEager }}</mat-label>
          <input matInput formControlName="newPassword" [formControl]="changePasswordForm.get('newPassword')" [type]="newPasswordVisible ? 'text' : 'password'" />
          <img
            class="change-password__icon"
            alt="{{ 'CHANGE_PASSWORD.NEW_PASSWORD' | i18nextEager }}"
            [src]="!newPasswordVisible ? '/assets/icons/eye.svg' : '/assets/icons/eye-gray.svg'"
            (click)="newPasswordVisible = !newPasswordVisible "
          />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'CHANGE_PASSWORD.REPEAT_NEW_PASSWORD' | i18nextEager }}</mat-label>
          <input matInput formControlName="repeatNewPassword" [formControl]="changePasswordForm.get('repeatNewPassword')" [type]="repeatNewPasswordVisible ? 'text' : 'password'" />
          <img
            class="change-password__icon"
            alt="{{ 'CHANGE_PASSWORD.NEW_PASSWORD' | i18nextEager }}"
            [src]="!repeatNewPasswordVisible ? '/assets/icons/eye.svg' : '/assets/icons/eye-gray.svg'"
            (click)="repeatNewPasswordVisible = !repeatNewPasswordVisible "
          />
        </mat-form-field>
        <mat-error *ngIf="changePasswordForm.errors?.format" class="change-password__error">
          {{ 'CHANGE_PASSWORD.PASSWORD_FORMAT_ERROR' | i18nextEager }}
        </mat-error>
        <mat-error *ngIf="changePasswordForm.errors?.notMatch" class="change-password__error">
          {{ 'CHANGE_PASSWORD.PASSWORD_NOT_MATCH_ERROR' | i18nextEager }}
        </mat-error>
      </form>
    </div>
    <div class="modal__footer">
      <button class="secondary">{{ 'COMMONS.CANCEL' | i18nextEager }}</button>
      <button [disabled]="changePasswordForm.invalid" (click)="onSubmit()">{{ 'COMMONS.SAVE' | i18nextEager }}</button>
    </div>
  </div>
</div>
